import { render, staticRenderFns } from "./SectionImageWrap.vue?vue&type=template&id=90c8cde0&scoped=true&"
import script from "./SectionImageWrap.vue?vue&type=script&lang=js&"
export * from "./SectionImageWrap.vue?vue&type=script&lang=js&"
import style0 from "./SectionImageWrap.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionImageWrap.vue?vue&type=style&index=1&id=90c8cde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c8cde0",
  null
  
)

export default component.exports